import { render, staticRenderFns } from "./ywyNotReached.vue?vue&type=template&id=51ef0161&scoped=true&"
import script from "./ywyNotReached.vue?vue&type=script&lang=js&"
export * from "./ywyNotReached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef0161",
  null
  
)

export default component.exports